export const initialValues = {
  number: "",
  access: null,
  employeeNumber: "",
  idStation: null,
}

export const required = {
  number: { required: true  },
  access: { required: true  },
  employeeNumber: { required: true  },
  idStation: { required: true  },
}